
document.addEventListener('DOMContentLoaded', function () {
    function show_hide_color() {
        $('.product-color-swatch-wrapper .swatch').removeClass('hidden');
        $('.variant_list .variant_item .item:not(.active)').each(function () {
            const htmlContent = $(this).attr('data');
            $(this).parents('.variant_list').find(`.swatch[data*='${htmlContent}']`).addClass('hidden');
        });
    }
    show_hide_color();
    $('.product-color-swatch-wrapper .swatch').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        let variant_id = $(this).data('id');
        $(this)
            .parents('.top_wrapper')
            .find('.price_list')
            .find(`.price[data-id=${variant_id}]`)
            .addClass('active')
            .siblings()
            .removeClass('active');
        $(this)
            .parents('.product_item')
            .find(`.variant-img[data-id='${variant_id}']`)
            .removeClass('hidden')
            .siblings()
            .addClass('hidden');
        $(this).parents('.top_wrapper').find('add-cart-button').attr('data-variant-id', variant_id);
    });
    $('.variant_list .variant_item .item,.product_select .select_item .item').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active').siblings().removeClass('active');

            if ($(this).attr('data') == 'custom-item') {
                // $(this).parents('.top_wrapper').find('.square').hide();

                $(this).parents('.product_item').find('a').attr('href', $(this).data('url'));
                $(this).parents('.top_wrapper').find('.product_color_item').eq(0).removeClass('active');
                $(this).parents('.top_wrapper').find('.product_color_item').eq(1).addClass('active');
                $(this).parents('.top_wrapper').find('h3').eq(0).addClass('hidden');
                $(this).parents('.top_wrapper').find('h3').eq(1).removeClass('hidden');
                $(this).parents('.product_item').find('.custom_tag').eq(0).addClass('hidden');
                $(this).parents('.product_item').find('.custom_tag').eq(1).removeClass('hidden');
                $(this)
                    .parents('.top_wrapper')
                    .find(`.product_color_item.active .product-color-swatch-wrapper .swatch`)
                    .eq(0)
                    .click();
                if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                    $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C')
                }
            } else {
                if ($(this).parents('.product_item').find('.product_color_item').length > 1) {
                    $(this).parents('.product_item').find('a').attr('href', $(this).parents('.product_info').data('url'));
                    $(this).parents('.top_wrapper').find('.square').show();
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(1).removeClass('active');
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(0).addClass('active');
                    $(this).parents('.top_wrapper').find('h3').eq(1).addClass('hidden');
                    $(this).parents('.top_wrapper').find('h3').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.custom_tag').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.custom_tag').eq(1).addClass('hidden');
                }
                if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                    $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C + Wireless Charging')
                }
                show_hide_color();
                $(this)
                    .parents('.top_wrapper')
                    .find(`.product_color_item.active .product-color-swatch-wrapper .swatch:not(.hidden)`)
                    .eq(0)
                    .click();
            }
              if ($(this).parents('.product_item').hasClass('openmeet') && $(this).attr('data') == 'No Adapter') {
                $(this).parents('.product_item').find('.custom_tag').text('35% OFF')
            } else {
                $(this).parents('.product_item').find('.custom_tag').text('30% OFF')
            }
        }
    });

    $('.product_info .top_wrapper .title').click(function () {
        $(this).toggleClass('active')
        $(this).find('.product_select').slideToggle()
    })

    $('.product_info.opencomm2uc-2025-upgrade .variant_list .variant_values .item:first-child').click();
    $('.product_info.openfit2plus .variant_list .variant_values .item:first-child').click();
    $('.product_item.openmeet .variant_values .item:nth-child(2)').click();

    $('.product_info.openmeet .variant_item.active .item:last-child').click();
  
    $(".product_info .swatch[data-id='43950801682531']").click();
    $(".product_info .swatch[data-id='43951010512995']").click();
  

    $('.bottom_item .bottom_cart .add_btn,.slide_card .slide_bottom .add_btn').click(function () {

        $(this).parents('.bottom_item').find('add-cart-button').eq(0).click();

    });
    $('.top_wrapper add-cart-button').click(function () {
        let id = $(this).attr('data-variant-id');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { id: id },
            dataType: 'json',
            success: function () {
                window.location.href = '/cart';
            },
        });
    });
});
